import type { SecurityLevel } from '../types/security';

export interface SiteAccessInput {
  sessionReady: boolean;
  securityLevel?: SecurityLevel | null;
  allowedLocationIds?: string[] | null;
}

export interface SiteAccessState {
  requiresSiteAssignment: boolean;
  hasAssignedSite: boolean;
  isBlocked: boolean;
}

export function getSiteAccessState(input: SiteAccessInput): SiteAccessState {
  const requiresSiteAssignment = input.securityLevel === 'user' || input.securityLevel === 'manager';
  const hasAssignedSite = (input.allowedLocationIds || []).some(Boolean);

  return {
    requiresSiteAssignment,
    hasAssignedSite,
    isBlocked: Boolean(input.sessionReady && requiresSiteAssignment && !hasAssignedSite),
  };
}
